<template>
  <version-card title="服务更新">
    <detect-updates :data="updateList"></detect-updates>
    <div class="public-title">近30天升级记录</div>
    <version-record :services="services" />
    <div class="height128"></div>
  </version-card>
</template>

<script>
import Card from "@/components/dashboard/devops/version/card.vue";
import Updates from "@/components/dashboard/devops/version/detect-updates.vue";
import versionRecord from "@/components/dashboard/devops/version/overview/record.vue";
import { ref } from "vue";
export default {
  name: "system-update-info",
  components: {
    [Card.name]: Card,
    [Updates.name]: Updates,
    [versionRecord.name]: versionRecord
  },
  setup() {
    const updateList = ref([
      {
        name: "设备服务 v1.1",
        value: "a"
      },
      {
        name: "统一身份认证 v1.3",
        value: "b"
      },
      {
        name: "空间服务 v1.2",
        value: "c"
      },
      {
        name: "人脸识别服务 v1.1",
        value: "d"
      }
    ]);
    const services = ref([
      {
        key: "1",
        src: require("@/assets/img/product-service/list_img10.jpg"),
        title: "舒适度指标计算服务",
        version: "1.2.0",
        updateTime: "2022/02/20  09:26:55",
        typeName: "服务"
      },
      {
        key: "2",
        src: require("@/assets/img/product-service/list_img1.jpg"),
        title: "能耗指标计算服务",
        version: "1.2.0",
        updateTime: "2022/01/30  09:26:39",
        typeName: "服务"
      }
    ]);
    return { updateList, services };
  }
};
</script>
<style scoped lang="less">
.public-title {
  margin: 24px 0 16px;
}
</style>
